import { Injectable, inject } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ConfiguracaoSistemaService } from '../features/PainelDeControle/manutencao/services/ConfiguracaoSistema.service';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate {
  private readonly _router = inject(Router);
  private readonly _configuracaoSistemaService = inject(ConfiguracaoSistemaService);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      const isUnderMaintenance = await firstValueFrom(
        this._configuracaoSistemaService.GetStatusSistema()
      );

      if (isUnderMaintenance) {
        this._router.navigate(['/maintenance']);
        return false;
      }

      return true;
    } catch (error) {
      console.error('Erro ao verificar status de manutenção:', error);
      return true;
    }
  }
}
